import { Component, Input } from '@angular/core';
import { WhiskeyItem } from '../../menu.model'

@Component({
  selector: 'other',
  templateUrl: './other.component.html',
  styleUrls: ['./other.component.scss']
})
export class OtherComponent {

  @Input() whiskeyList: Array<WhiskeyItem> = [];
  @Input() activeSection: string | undefined;

  constructor() {}

}
